import { type Attachment } from "../../containers/Album/types/attachment.types.ts"

interface Args {
  file: Attachment
  allowed: boolean
  foreignAllowed: boolean
  currentUserId: string
}

export function showFileAction({
  file,
  allowed,
  foreignAllowed,
  currentUserId
}: Args) {
  if (foreignAllowed) return true

  return allowed && file?.created_by === currentUserId
}
